import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { SelfLearnService } from 'projects/selflearnv2-ui/src/app/services/self-learn/self-learn.service';

@Component({
  selector: 'app-documents-page',
  templateUrl: './documents-page.component.html',
  styleUrls: ['./documents-page.component.css']
})
export class DocumentsPageComponent implements OnInit {

  title: string = 'Documents';
  docsData:any;
  pdfUrl:any;

  constructor(public selfLearnService:SelfLearnService,public router:Router) { }

  ngOnInit(): void {
    this.docsData = JSON.parse(localStorage.getItem('documentsData'));
    console.log(this.docsData);
  }

  navigateToChaperPage(){
    this.router.navigate([`selfLearn-V2/chapter`]);
  }
  openPdf(doc:any){
    this.updateDocProgress(doc.documentId);
    this.pdfUrl = doc.contentURL;
    localStorage.setItem('currentPdfUrl', JSON.stringify(doc));
    this.router.navigate([`selfLearn-V2/view-pdf`]);
    
  }
  updateDocProgress(docId:any){
   this.selfLearnService.updateDocumentProgress(docId).subscribe((res:any) => {
      
   })
  }

}
